import {ViewContainerRef} from '@angular/core';

export class DialogConfig {

    data?: any;

    viewContainerRef?: ViewContainerRef;

    disableClose?: boolean = false;

    noPadding?: boolean = false;

}
